var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDailySatsang(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.394 217.118C218.522 225.952 220.607 235.635 215.877 245.92C211.095 256.32 202.565 261.729 190.963 261.746C162.12 261.786 133.275 261.906 104.433 261.692C93.2367 261.609 85.0551 255.887 80.4927 245.765C76.046 235.901 77.6604 226.519 84.4064 218.041C84.7014 217.67 84.8669 217.196 85.1904 216.586C91.7941 223.837 98.9779 229.353 107.193 233.433C110.73 235.19 114.382 236.789 118.118 238.061C124.677 240.292 131.334 237.102 133.642 230.608C135.484 225.425 137.115 220.15 138.515 214.831C140.271 208.16 137.294 202.819 131.053 199.628C126.623 197.365 122.413 194.626 118.31 191.802C117.274 191.089 116.616 189.276 116.482 187.9C115.888 181.836 115.569 175.746 115.107 169.668C114.965 167.798 114.696 165.915 112.373 165.428C110.025 164.935 108.867 166.371 107.81 168.156C101.585 178.667 104.288 191.108 115.092 199.508C118.63 202.259 122.791 204.269 126.825 206.304C130.987 208.405 131.826 209.808 130.563 214.314C129.234 219.058 127.943 223.816 126.505 228.528C125.551 231.651 123.358 232.963 120.542 231.94C104.241 226.019 90.8318 216.472 83.2159 200.407C74.1917 181.37 78.0327 160.322 92.6861 145.168C101.576 135.973 112.21 129.76 124.401 126.156C125.499 125.832 127.114 126.08 128.089 126.696C141.585 135.217 154.992 135.154 168.44 126.619C169.244 126.108 170.46 125.602 171.268 125.838C189.653 131.213 204.803 141.054 213.408 158.711C222.216 176.788 219.549 194.065 207.74 210C199.765 220.761 188.772 227.471 176.414 232.105C173.192 233.314 170.895 232.133 169.887 228.831C168.336 223.75 166.891 218.636 165.497 213.509C164.609 210.245 165.562 208.419 169.051 206.93C174.7 204.519 180.014 201.622 184.377 197.212C193.25 188.244 194.746 176.824 188.375 167.14C187.337 165.564 186.159 164.393 184.121 164.886C182.075 165.381 181.569 166.932 181.438 168.841C180.98 175.5 180.487 182.158 179.877 188.804C179.782 189.842 179.282 191.211 178.501 191.756C174.729 194.393 170.977 197.161 166.876 199.196C161.998 201.616 157.398 204.527 157.596 210.296C157.895 219.025 160.471 227.467 165.212 234.843C168.026 239.221 173.574 240.104 178.834 238.224C190.485 234.06 200.819 227.81 209.372 218.772C209.771 218.351 210.173 217.931 210.595 217.532C210.724 217.409 210.92 217.357 211.394 217.118Z",
    fill: "url(#paint0_linear_2571_477)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7152 230.175C70.5794 236.167 70.6479 242.178 72.3919 247.657C76.8886 261.784 89.9758 270.835 104.782 270.851C133.809 270.882 162.836 270.897 191.863 270.848C212.651 270.812 228.563 252.436 225.778 231.808C225.652 230.873 225.552 229.935 225.382 228.52C237.559 232.397 249.317 236.178 257.978 245.753C263.04 251.349 263.044 258.073 258.28 263.937C253.763 269.495 247.693 272.896 241.298 275.752C227.599 281.87 213.107 285.113 198.365 287.415C175.043 291.057 151.581 291.777 128.073 290.238C106.997 288.859 86.0964 286.032 66.1953 278.529C59.8367 276.132 53.8544 272.637 47.9262 269.248C45.5701 267.902 43.6223 265.652 41.8481 263.515C37.7463 258.574 37.4681 252.709 41.2267 247.468C42.9457 245.07 45.1345 242.892 47.468 241.075C54.2616 235.782 62.1945 232.732 69.7152 230.175Z",
    fill: "url(#paint1_linear_2571_477)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.259 68.9587C163.942 69.0708 176.428 81.7125 176.291 97.3398C176.155 112.841 163.379 125.192 147.586 125.091C132.6 124.994 119.872 111.851 120.072 96.6755C120.273 81.389 133.025 68.8495 148.259 68.9587Z",
    fill: "url(#paint2_linear_2571_477)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5687 43.3328C98.5751 46.5444 95.2352 48.6443 92.8786 46.8063C90.0242 44.5803 87.4294 41.9193 85.1784 39.0841C84.4798 38.2037 84.7632 35.7721 85.5269 34.736C86.1913 33.8341 88.7953 33.1279 89.4562 33.6669C92.6201 36.2466 95.4309 39.2635 98.3161 42.176C98.596 42.4582 98.5223 43.0912 98.5687 43.3328Z",
    fill: "url(#paint3_linear_2571_477)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.091 103.125C205.453 103.125 203.799 103.271 202.183 103.089C199.971 102.84 198.662 101.42 198.682 99.2012C198.7 97.1279 199.959 95.5959 202.013 95.4606C205.367 95.2393 208.757 95.244 212.111 95.4647C214.148 95.5982 215.436 97.0408 215.456 99.1704C215.477 101.42 214.214 102.825 211.998 103.078C210.382 103.262 208.728 103.114 207.091 103.114C207.091 103.117 207.091 103.121 207.091 103.125Z",
    fill: "url(#paint4_linear_2571_477)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M229.286 103.165C227.743 103.163 226.183 103.311 224.663 103.129C222.4 102.857 220.883 101.618 220.937 99.1496C220.986 96.8429 222.44 95.5379 224.577 95.3962C227.648 95.193 230.749 95.2017 233.824 95.366C236.089 95.4868 237.71 96.7738 237.713 99.2071C237.716 101.595 236.231 102.923 233.909 103.139C232.381 103.282 230.828 103.167 229.286 103.165Z",
    fill: "url(#paint5_linear_2571_477)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.276 59.0441C114.264 62.2644 110.918 64.3429 108.577 62.4996C105.734 60.2608 103.143 57.6016 100.898 54.7635C100.205 53.8871 100.501 51.4625 101.266 50.4311C101.932 49.5338 104.527 48.8346 105.183 49.3724C108.34 51.9602 111.146 54.9812 114.025 57.8989C114.305 58.1829 114.232 58.8148 114.276 59.0441Z",
    fill: "url(#paint6_linear_2571_477)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2406 101.218C87.701 101.218 86.1556 101.304 84.6236 101.197C82.5428 101.052 81.221 99.9309 81.012 97.7833C80.7866 95.4667 82.0643 93.8603 84.1631 93.6698C87.5936 93.3591 91.0868 93.3975 94.526 93.6547C96.5377 93.8052 97.8316 95.3761 97.7683 97.4604C97.7015 99.6451 96.4116 101.052 94.1473 101.215C92.5195 101.332 90.8771 101.238 89.2406 101.238C89.2406 101.231 89.2406 101.224 89.2406 101.218Z",
    fill: "url(#paint7_linear_2571_477)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153.033 17.4901C153.034 18.9327 153.151 20.3869 153.007 21.815C152.777 24.1002 151.564 25.6119 149.112 25.5916C146.846 25.5724 145.462 24.2634 145.354 22.0391C145.201 18.8758 145.204 15.6956 145.332 12.5306C145.422 10.3034 146.839 8.90787 149.027 8.84863C151.393 8.78475 152.759 10.293 152.999 12.591C153.168 14.2072 153.032 15.8553 153.033 17.4901Z",
    fill: "url(#paint8_linear_2571_477)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M153.042 39.4675C153.042 41.0059 153.148 42.5535 153.018 44.0815C152.817 46.4265 151.433 47.8569 149.081 47.8389C146.873 47.8221 145.441 46.4748 145.345 44.2331C145.21 41.0674 145.205 37.8872 145.347 34.7222C145.446 32.5037 146.822 31.1477 149.068 31.1064C151.49 31.0617 152.767 32.5618 153.002 34.8546C153.157 36.3773 153.031 37.9291 153.031 39.468C153.035 39.4675 153.039 39.4675 153.042 39.4675Z",
    fill: "url(#paint9_linear_2571_477)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0261 101.252C65.4872 101.252 63.9424 101.342 62.4115 101.23C60.1635 101.067 58.8887 99.7658 58.7946 97.5096C58.7052 95.3556 59.93 93.8294 61.9405 93.6714C65.3762 93.402 68.859 93.4118 72.2993 93.6453C74.3505 93.7847 75.5747 95.3753 75.523 97.4475C75.4685 99.6345 74.2088 101.05 71.9311 101.203C70.3033 101.312 68.6621 101.225 67.0267 101.225C67.0267 101.234 67.0261 101.243 67.0261 101.252Z",
    fill: "url(#paint10_linear_2571_477)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M197.578 53.3542C197.631 56.4774 189.593 64.6648 187.206 64.3355C186.041 64.1746 184.502 63.3262 184.044 62.3581C183.534 61.2796 183.538 59.2853 184.232 58.4351C186.407 55.7695 188.873 53.2856 191.531 51.102C192.383 50.4022 194.351 50.4377 195.497 50.9034C196.529 51.3221 197.134 52.7908 197.578 53.3542Z",
    fill: "url(#paint11_linear_2571_477)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M213.303 38.4121C213.315 40.85 205.266 48.7708 202.836 48.7133C200.02 48.6466 197.929 45.3828 199.654 43.1573C201.926 40.2263 204.613 37.5171 207.517 35.2087C209.832 33.3683 213.29 35.4926 213.303 38.4121Z",
    fill: "url(#paint12_linear_2571_477)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2571_477",
    x1: 148.308,
    y1: 125.778,
    x2: 148.308,
    y2: 261.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2571_477",
    x1: 150.197,
    y1: 228.52,
    x2: 150.197,
    y2: 291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2571_477",
    x1: 148.181,
    y1: 68.958,
    x2: 148.181,
    y2: 125.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2571_477",
    x1: 91.674,
    y1: 33.4795,
    x2: 91.674,
    y2: 47.4911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2571_477",
    x1: 207.069,
    y1: 95.2969,
    x2: 207.069,
    y2: 103.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2571_477",
    x1: 229.324,
    y1: 95.2432,
    x2: 229.324,
    y2: 103.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2571_477",
    x1: 107.392,
    y1: 49.1846,
    x2: 107.392,
    y2: 63.1909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2571_477",
    x1: 89.3784,
    y1: 93.4492,
    x2: 89.3784,
    y2: 101.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2571_477",
    x1: 149.161,
    y1: 8.84668,
    x2: 149.161,
    y2: 25.5918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2571_477",
    x1: 149.162,
    y1: 31.1055,
    x2: 149.162,
    y2: 47.8391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2571_477",
    x1: 67.1573,
    y1: 93.4697,
    x2: 67.1573,
    y2: 101.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2571_477",
    x1: 190.631,
    y1: 50.5635,
    x2: 190.631,
    y2: 64.3452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2571_477",
    x1: 206.165,
    y1: 34.5215,
    x2: 206.165,
    y2: 48.7137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F36"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailySatsang);
export default __webpack_public_path__ + "static/media/DailySatsang.64ac7c4fb4ceb0d23109f74e8d47c844.svg";
export { ForwardRef as ReactComponent };